import { type ObjectMode } from '@databases/types';
import { type Database, DatabaseFieldType } from '@databases/types/database';
import { createField, getExistingDatabase } from '@databases/utils/database/utils';

import { databasesToContentId } from './constants';

export const getDatabaseWithSelfReferenceEntryLinkField =
  (): Database<ObjectMode.EXISTING> => {
    const contentId = databasesToContentId['databaseWithSelfReferenceEntryLinkField'];
    const baseDatabase = getExistingDatabase({ contentId });

    const baseEntryLinkField = createField(DatabaseFieldType.ENTRY_LINK);
    const baseEntryLinkFieldMulti = createField(DatabaseFieldType.ENTRY_LINK);
    const fields = [
      {
        ...createField(DatabaseFieldType.TEXT),
        name: `Text Field`,
      },
      {
        ...baseEntryLinkField,
        name: `Entry Link Field Single`,
        settings: {
          ...baseEntryLinkField.settings,
          contentId,
          multi: false,
        },
      },
      {
        ...baseEntryLinkFieldMulti,
        name: `Entry Link Field Multi`,
        settings: {
          ...baseEntryLinkFieldMulti.settings,
          contentId,
          multi: true,
        },
      },
    ];

    return {
      ...baseDatabase,
      fields: fields.map((field) => field.id),
      fieldsById: Object.fromEntries(fields.map((field) => [field.id, field])),
    };
  };
